module.exports = new __parcel__URL__("loader.40e04524.svg").toString();